if (!customElements.get('engagement-model')) {
  customElements.define(
    'engagement-model',
    class EngagementModel extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.resizeTimeout = null;
      }

      get isMobile() {
        return window.matchMedia('(max-width: 989px)').matches;
      }

      get sectionId() {
        return this.getAttribute('data-section-id');
      }

      get selector() {
        return `#engagement-model-${this.sectionId}`;
      }

      connectedCallback() {
        this.handleResize();

        this.resizeObserver = new ResizeObserver(() => this.handleResize());
        this.resizeObserver.observe(this);

        this.handleWindowResize = () => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => this.handleResize(), 100);
        };
        window.addEventListener('resize', this.handleWindowResize);
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.handleWindowResize);
        clearTimeout(this.resizeTimeout);
      }

      handleResize() {
        if (this.isMobile) {
          if (!this.swiper) this.init();
        } else if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      init() {
        if (!this.isMobile || !this.sectionId || !window.Swiper) {
          return;
        }

        const swiperEl = document.querySelector(this.selector);
        if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) {
          return;
        }

        try {
          this.swiper = new Swiper(this.selector, {
            slidesPerView: 1,
            spaceBetween: 24,
            pagination: {
              el: `${this.selector} .engagement-model__pagination`,
              clickable: true,
              type: 'bullets',
            },
            loop: false,
            watchOverflow: true,
          });
        } catch (error) {
          console.error('Error initializing Engagement Model Swiper:', error);
        }
      }
    }
  );
}
